export enum CommandRight {
    Open,
    Add,
    Edit = 2,
    Delete = 3,
    Print = 4,
    PrintDocument = 5,
    AuthorizeDocument = 6,
    GereedMelden = 7,
    Doorboeken = 8,
    EditNotes = 9,
    DefineReportLayout = 11,
    DefineDocumentLayout = 12,
    DefineDoorboekVerslagLayout = 13
}